<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1003648')" prop="billingTime">
              <Date-picker
                type="month"
                class="wid100P"
                v-model="pageParams.billingTime"
                :clearable="true"
                format="yyyy-MM"
                placement="bottom-end"
                :placeholder="$t('key1000360')">
              </Date-picker>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1000333')" prop="ymsWarehouseId">
              <Select v-model="pageParams.ymsWarehouseId" filterable>
                <Option v-for="item in warehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--导出数据-->
      <Dropdown transfer @on-click="changeExportBtn" class="mr15" v-if="getPermission('ymsBill_exportWarehouseBill') ||
        getPermission('ymsBill_exportWarehouseDetailBill')">
        <Button type="primary">
          <span>{{ $t('key1003082') }}</span>
          <Icon type="ios-arrow-down"></Icon>
        </Button>
        <DropdownMenu slot="list">
          <DropdownItem name="1">{{ $t('key1003083') }}</DropdownItem>
          <DropdownItem name="2">{{ $t('key1003084') }}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <!--更新账单-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsBill_updateWarehouseBill')" @click="updateWarehouseBillBtn">{{ $t('key1003901') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        border
        max-height="530"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--导出数据字段弹窗-->
    <exportFieldsModal
      ref="exportFields"
      :dimensionTalg="true"
      :exportFieldsTitle="$t('key1003900')"
      paramKeyColums="ymsWarehouseBillHandlerColumns"
      :customFieldExportList="customFieldExportList"
      :dimensionTypeList="dimensionTypeList"
      @exportFieldsDataBtn="exportFieldsDataBtn">
    </exportFieldsModal>
    <!--日志弹窗-->
    <commonLogModal ref="commonLog" logMode="YMS_STANDARD" :logType="['SYSTEM_LOG']"></commonLogModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import exportFieldsModal from "@/components/common/exportFieldsModal";
import commonLogModal from "@/components/common/commonLogModal";
import {getUserNameByUserId, pageJump, setConfigCharacters, getEnableWarehouseData,
  getAllUsersInfo, getDataSetBatchList, getEnumName} from "@/utils/common";

export default {
  name: "warehouseBill",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        billingTime: null,
        ymsWarehouseId: 'null',
        pageNum: 1,
        pageSize: 15
      },
      total: 0,
      tableColumns: [
        {
          type: 'selection',
          width: 60,
          fixed: 'left',
          key: 'selection',
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612'),
          key: 'billNo',
          align: 'left',
          minWidth: 160,
          fixed: 'left',
          render(h, params) {
            return h('Alink', {
              props: {
                linkName: params.row.billNo
              },
              on: {
                AlinkBtn: () => {
                  v.$router.push({
                    path: '/warehouseBillDetails',
                    query: {
                      ymsBillId: params.row.ymsBillId
                    }
                  });
                }
              }
            });
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          key: 'ymsWarehouseId',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let text = '';
            let ymsWarehouseId = params.row.ymsWarehouseId;
            v.warehouseList.map((item) => {
              if (item.ymsWarehouseId === ymsWarehouseId) {
                text = item.name;
              }
            });
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884'),
          key: 'status',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let status = params.row.status;
            let text = getEnumName(v.enumData, 'YmsBillSettlementStatusCoreEnum', status, 'number');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613'),
          key: 'billMonth',
          minWidth: 120,
          align: 'left',
          render(h, params) {
            let date = '-';
            let billMonth = params.row.billMonth;
            if (billMonth) {
              let time = billMonth.split('-');
              date = `${time[0]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000492')}${time[1]}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000493')}`;
            }
            return h('span', date);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003885'),
          key: 'totalPrice',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let packageHandlerCost = params.row.packageHandlerCost || 0;
            let packageMaterialCost = params.row.packageMaterialCost || 0;
            let additionalServiceCost = params.row.additionalServiceCost || 0;
            let packageReturnHandlerCost = params.row.packageReturnHandlerCost || 0;
            let warehouseCost = params.row.warehouseCost || 0;
            let totalPrice = packageHandlerCost + packageMaterialCost + additionalServiceCost + packageReturnHandlerCost + warehouseCost;
            let text = v.formatCurrency(totalPrice);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003886'),
          key: 'packageQuantity',
          minWidth: 110,
          align: 'left'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213'),
          key: 'packageHandlerCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageHandlerCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003756'),
          key: 'packageMaterialCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageMaterialCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003757'),
          key: 'additionalServiceCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.additionalServiceCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003758'),
          key: 'packageReturnHandlerCost',
          minWidth: 150,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.packageReturnHandlerCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003887'),
          key: 'warehouseCost',
          minWidth: 130,
          align: 'left',
          render(h, params) {
            let currency = params.row.currency || v.currencyState;
            let text = v.formatCurrency(params.row.warehouseCost);
            return h('span', text + ' ' + currency);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003888'),
          key: 'updatedTime',
          minWidth: 180,
          align: 'left',
          render(h, params) {
            let updatedTime = params.row.updatedTime;
            let time = updatedTime ? v.$uDate.dealTime(updatedTime, 'fulltime') : '-';
            return h('span', time);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292'),
          key: 'updatedBy',
          minWidth: 120,
          align: 'left',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.updatedBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 200,
          fixed: 'right',
          render(h, params) {
            let ymsBillId = params.row.ymsBillId;
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$router.push({
                        path: '/warehouseBillDetails',
                        query: {
                          ymsBillId: ymsBillId
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
                    show: status === 1 && v.getPermission('ymsBill_confirmWarehouseSettlement'),
                    clickFn: () => {
                      v.confirmSettlementBtn(ymsBillId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002478'),
                    show: true,
                    clickFn: () => {
                      v.$refs['commonLog'].initCommonLogData(ymsBillId);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      billingTime: [],
      warehouseList: [],
      selectTableData: [],
      exportType: '1',
      customFieldExportList: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003620'),
          titleKey: 'basicInfoColums',
          selectList: [], // 选中导出字段的key
          checkBoxList: [
            {type: [1, 2], paramKey: 'billNo', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003612')},
            {type: [1, 2], paramKey: 'warehouseName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328')},
            {type: [1, 2], paramKey: 'statusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003884')},
            {type: [1, 2], paramKey: 'billingTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003613')},
            {type: [1, 2], paramKey: 'totalAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003885')},
            {type: [1, 2], paramKey: 'packageQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003889')},
            {type: [1, 2], paramKey: 'packageMaterialCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003890')},
            {type: [1, 2], paramKey: 'additionalServiceCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003891')},
            {type: [1, 2], paramKey: 'packageReturnHandlerCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003892')},
            {type: [1, 2], paramKey: 'warehouseCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003893')},
            {type: [1, 2], paramKey: 'updatedTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003888')},
            {type: [1, 2], paramKey: 'updatedByName', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000292')}
          ]
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003610'),
          titleKey: 'ymsWarehouseBillDetailHandlerColumns',
          selectList: [],
          checkBoxList: [
            {type: [2], paramKey: 'packageCode', paramValue: `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000522')}`},
            {type: [2], paramKey: 'billNoDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003622')},
            {type: [2], paramKey: 'warehouseNameDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002390')},
            {type: [2], paramKey: 'distributorMerchantId', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003173')},
            {type: [2], paramKey: 'statusStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002917')},
            {type: [2], paramKey: 'productQuantity', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003755')},
            {type: [2], paramKey: 'packageHandlerCostStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001213')},
            {type: [2], paramKey: 'packageMaterialCostStrDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003894')},
            {type: [2], paramKey: 'additionalServiceCostStrDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003895')},
            {type: [2], paramKey: 'packageReturnHandlerCostStrDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003896')},
            {type: [2], paramKey: 'warehouseCostStrDetail', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003887')},
            {type: [2], paramKey: 'totalAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003897')},
            {type: [2], paramKey: 'actuallyAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003760')},
            {type: [2], paramKey: 'subAmountStr', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003705')},
            {type: [2], paramKey: 'remark', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000350')},
            {type: [2], paramKey: 'createdTime', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003761')},
            {type: [2], paramKey: 'source', paramValue: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003707')}
          ]
        }
      ],
      userInfoList: {},
      enumData: []
    };
  },
  computed: {
    dimensionTypeList() {
      let list = [
        {value: 1, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003644'), permissionKey: 'ymsBill_exportWarehouseBill'},
        {value: 2, label: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003645'), permissionKey: 'ymsBill_exportWarehouseDetailBill'}
      ];
      list.map((item) => {
        item['show'] = this.getPermission(item.permissionKey);
      });
      return list;
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      let v = this;
      (async () => {
        let enumKeyList = ['YmsBillSettlementStatusCoreEnum'];
        v.enumData = await getDataSetBatchList(enumKeyList);
        await getEnableWarehouseData(3).then((data) => {
          v.warehouseList = data;
          v.warehouseList.unshift({
            ymsWarehouseId: 'null',
            name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110')
          });
        });
        await getAllUsersInfo().then((data) => {
          v.userInfoList = data;
        });
        await v.getList();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.selectTableData = [];
      v.$refs['pageParams'].resetFields();
      v.getList();
    },
    // 勾选列表数据
    tableChange(data) {
      this.selectTableData = [];
      if (data) {
        this.selectTableData = data.map((item) => {
          return item.ymsBillId;
        });
      }
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      params.ymsWarehouseId = v.pageParams.ymsWarehouseId === 'null' ? null : v.pageParams.ymsWarehouseId;
      params.billingTime = v.pageParams.billingTime ? v.$uDate.getDateTime(v.pageParams.billingTime, 'month') : null;
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.optionBtnWidth = [];
      v.selectTableData = [];
      v.tableData = [];
      v.total = 0;
      v.$nextTick(() => {
        v.$refs['selection'].selectAll(false);
      });
      if (v.getPermission('ymsBill_queryForWarehouseBill')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsBill_queryForWarehouseBill, v.handleParameter()).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              v.tableData = data.list || [];
              v.updateTableDom('selection');
              v.total = data.total;
            }
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 选择导出数据类型  1 按选中导出 2 按查询结果导出
    changeExportBtn(value) {
      this.exportType = value;
      if (value === '1') {
        if (this.selectTableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003077'));
          return false;
        }
      } else {
        if (this.tableData.length <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003078'));
          return false;
        }
      }
      this.$refs['exportFields'].getExportFieldsSetting();
    },
    // 导出数据
    exportFieldsDataBtn() {
      let v = this;
      let query = v.handleParameter();
      if (v.exportType === '1') {
        query.ymsBillIds = v.selectTableData;
      } else {
        query.ymsBillIds = [];
      }
      v.$refs['exportFields'].saveExportFieldsSetting().then((data) => {
        if (data) {
          let dimensionType = data.dimensionType;
          let url = dimensionType === 1 ? api.post_ymsBill_exportWarehouseBill : api.post_ymsBill_exportWarehouseDetailBill;
          v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
            if (res.data.code === 0) {
              v.$refs['exportFields'].exportFieldsModal = false;
              let taskNumber = res.data.datas;
              setTimeout(() => {
                pageJump('/yms.html#/exportTask?operateCode=' + taskNumber, '/yms-core-service', '_blank');
              }, 30);
            }
          });
        }
      });
    },
    // 确认结算
    confirmSettlementBtn(ymsBillId) {
      let v = this;
      v.$Modal.confirm({
        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003711'),
        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003712'),
        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002019'),
        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
        onOk: () => {
          v.axios.put(api.put_ymsBill_confirmWarehouseSettlement + ymsBillId, null,
            {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003713'));
              v.pageParamsStatus = true;
            }
          });
        },
        onCancel: () => {
        }
      });
    },
    // 更新账单
    updateWarehouseBillBtn() {
      let v = this;
      if (v.selectTableData.length > 0) {
        v.axios.post(api.post_ymsBill_updateWarehouseBill, v.selectTableData, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(res => {
          if (res.data.code === 0) {
            v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003898'));
            v.pageParamsStatus = true;
          }
        });
      } else {
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003899'));
        return false;
      }
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    },
  },
  components: {
    exportFieldsModal,
    commonLogModal
  }
};
</script>

<style lang="less" scoped>

</style>
